<template>
    <div>
        <div class="rounded-lg bg-white border-teal-500 border-t-8 shadow-xl py-4 md:py-10 px-6 md:px-8 text-gray-800">
            <div class="container flex items-center justify-between">
                <div class="w-full">
                    <div class="mb-3">
                        <h1 class="text-3xl font-hairline font-normal text-gray-800">Available Jobs</h1>
                    </div>
                    <form @submit.prevent="search">
                        <div class="lg:flex lg:flex-col">
                            <div class="flex flex-col md:flex-row items-center md:mb-8">
                                <my-input
                                    v-model="form.keyword"
                                    label="Keyword"
                                    name="keyword"
                                    class="mb-4 md:mb-0 md:mr-2"
                                    placeholder="By name or position..."
                                />
                                <div class="flex flex-col mb-4 md:mb-0 md:ml-2 w-full">
                                    <label class="font-bold mb-1">Budget ($)</label>
                                    <div class="flex flex-col md:flex-row items-center" style="max-width: 100%">
                                        <my-input
                                            v-model="form.rate_from"
                                            name="rate_from"
                                            type="number"
                                            class="md:mr-1"
                                            placeholder="Min"
                                        />
                                        <span> - </span>
                                        <my-input
                                            v-model="form.rate_to"
                                            name="rate_to"
                                            type="number"
                                            class="md:ml-1"
                                            placeholder="Max"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col md:flex-row items-start">
                                <my-multiselect
                                    v-model="form.selected_skills"
                                    :options="allSkills"
                                    label="Skills"
                                    label-by="name.en"
                                    name="selected_skills"
                                    placeholder="Select skills"
                                    class="mb-4 md:mb-0 md:mr-2"
                                />
                                <my-multiselect
                                    v-model="form.selected_countries"
                                    :options="allCountries"
                                    label-by="name"
                                    name="selected_countries"
                                    label="Countries"
                                    placeholder="Select countries"
                                    class="mb-4 md:mb-0 md:ml-2"
                                />
                            </div>
                            <div class="flex justify-between items-center mt-6">
                                <div>
                                    <a v-if="searchCompleted" href="#" @click.prevent="removeFilters">Remove all filters</a>
                                </div>
                                <my-button :loading="searching" class="btn btn-primary rounded-full" type="submit">
                                    Search
                                </my-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="mt-16">
            <div v-if="searchCompleted" class="mb-3">
                <p v-if="foundProjects.length === 0">No job found.</p>
                <div v-else class="flex justify-between items-center pb-6 border-b border-gray-200">
                    <h3 class="text-xl font-thin flex-grow">{{ foundProjects.length }} job(s) found.</h3>
                    <!-- <div class="w-64">
                        <my-select value="latest" :options="{ latest: 'Latest Projects', highest: 'Highest Budget' }"></my-select>
                    </div> -->
                </div>
            </div>
            <div v-if="foundProjects" class="grid grid-cols-1 col-gap-6 row-gap-8">
                <project-card v-for="project in foundProjects" :key="project.id" :project="project" />
            </div>
            <div v-else class="font-medium text-center">
                Sorry, there are no posted job in YaganKar at the moment, please check later.
            </div>
        </div>
    </div>
</template>

<script>
import Form from '../../forms/form';
let defaultVals = {
    keyword: null,
    selected_skills: [],
    selected_countries: [],
    rate_from: 1.0,
    rate_to: 500.0
};

export default {
    data() {
        return {
            allSkills: [],
            skills: null,
            allCountries: [],
            form: new Form(defaultVals),
            foundProjects: [],
            searchCompleted: false,
            searching: false
        };
    },

    mounted() {
        this.fetchAllProjects();
        this.fetchAllSkills();
        this.fetchCountries();
    },

    methods: {
        fetchAllProjects() {
            NProgress.inc();

            axios.get('/api/projects').then(response => {
                this.foundProjects = response.data.data;
                NProgress.done();
            });
        },

        removeFilters() {
            if (!confirm('All filtered results will be removed, are you sure?')) {
                return;
            }

            this.searchCompleted = false;
            this.form = new Form(defaultVals);
            this.fetchAllProjects();
        },

        search() {
            NProgress.inc();
            this.searching = true;

            this.form
                .post('/api/projects/advance-search')
                .then(response => {
                    this.foundProjects = response.data.data;
                    this.updateUrl();
                })
                .then(() => {
                    this.searching = false;
                    this.searchCompleted = true;
                    NProgress.done();
                });
        },

        fetchAllSkills() {
            axios.get(`/api/tags`).then(response => {
                this.allSkills = response.data.data;
            });
        },

        fetchCountries() {
            axios.get('/api/countries').then(response => {
                this.allCountries = response.data.data.map(country => {
                    return { name: country };
                });
            });
        },

        updateUrl() {
            if (history.pushState) {
                window.history.pushState({}, null, this.prepareSearchUrl());
            }
        },

        prepareSearchUrl() {
            function updateUrlParameter(uri, key, value) {
                // remove the hash part before operating on the uri
                var i = uri.indexOf('#');
                var hash = i === -1 ? '' : uri.substr(i);
                uri = i === -1 ? uri : uri.substr(0, i);

                var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
                var separator = uri.indexOf('?') !== -1 ? '&' : '?';

                if (!value || (Array.isArray(value) && _.isEmpty(value))) {
                    // remove key-value pair if value is empty
                    uri = uri.replace(new RegExp('([?&]?)' + key + '=[^&]*', 'i'), '');
                    if (uri.slice(-1) === '?') {
                        uri = uri.slice(0, -1);
                    }
                    // replace first occurrence of & by ? if no ? is present
                    if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
                } else if (uri.match(re)) {
                    uri = uri.replace(re, '$1' + key + '=' + value + '$2');
                } else {
                    uri = uri + separator + key + '=' + value;
                }
                return uri + hash;
            }

            let searchUrl = window.location.href;

            _.each(this.form, (value, field) => {
                if (!_.includes(_.keys(defaultVals), field)) {
                    return;
                }

                if (field === 'selected_skills') {
                    value = value.map(skill => skill.id);
                }

                if (field === 'selected_countries') {
                    value = value.map(country => country.name);
                }

                searchUrl = updateUrlParameter(searchUrl, field, value);
            });

            return encodeURI(searchUrl);
        }
    }
};
</script>
